// extracted by mini-css-extract-plugin
export default {"commands":"TreeBuilderFull_commands__ARyM6","wrapper":"TreeBuilderFull_wrapper__7f79O","inputWrapper":"TreeBuilderFull_inputWrapper__bUDfU"};